import React from 'react';
import { Button } from './Button';

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  variant?: 'danger' | 'warning' | 'info';
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  variant = 'danger'
}) => {
  if (!isOpen) return null;

  const variantClasses = {
    danger: 'border-danger text-danger',
    warning: 'border-warning text-warning',
    info: 'border-info text-info'
  };

    const buttonVariant = {
    danger: 'danger',
    warning: 'bordered-primary',
    info: 'filled-primary'
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-700 bg-opacity-50">
      <div className="bg-light rounded-lg shadow-lg max-w-md w-full mx-4">
        <div className={`p-6 border-l-4 ${variantClasses[variant]}`}>
          <h3 className="text-lg font-semibold mb-2">{title}</h3>
          <p className="text-grey_dark">{message}</p>
        </div>
        <div className="flex justify-end gap-3 p-6 pt-4">
          <Button
            onClick={onCancel}
            variant="bordered-primary"
            className="min-w-[80px]"
          >
            {cancelText}
          </Button>
          <Button
            onClick={onConfirm}
            variant={buttonVariant[variant] as any}
            className="min-w-[80px]"
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;